
/* eslint-disable */
import {
  wrapperStyles,
} from 'components/Templates/commonStyles/DefaultCssValues';


import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoSmall,
  typoParagraph,
  socialMediaIconStyles,
} from 'components/Templates/styles/Red/commonObjectsStyles';


import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg?url';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg?url';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg?url';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg?url';
import slackIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_slack.svg?url';


export default {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color': '{sectionBackgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  createdWith: {
    '0': {
      'flex': 1,
      'display': 'flex',
      'max-width': '30rem',
      'align-items': 'flex-end',
      'order': 2,
      'margin-top': '7rem',
      'color': '{textColor}'
    },
  },
  subsectionWrapper: {
    '0': {
      'display': 'flex'
    },
    '37_5': {
      'flex-wrap': 'wrap'
    }
  },
  subsectionOne: {
    '0': {
      'flex': '1',
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'min-width': '30rem',
    }
  },
  subsectionOneTitle: {
    '0': {
      ...typoSmall,
      'margin-bottom': '6rem'
    },
    '37_5': {
      'margin-top': '6rem'
    }
  },
  subsectionOneContent: {
    '0': {
      ...typoParagraph,
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'font-size': '2.4rem'
    }
  },
  subsectionTwo: {
    '0': {
      'flex': '1',
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'min-width': '30rem',
    }
  },
  subsectionTwoTitle: {
    '0': {
      ...typoSmall,
      'margin-bottom': '6rem'
    },
    '37_5': {
      'margin-top': '6rem'
    }
  },
  subsectionTwoContent: {
    '0': {
      ...typoParagraph,
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'font-size': '2.4rem'
    }
  },
  subsectionThree: {
    '0': {
      'flex': '1',
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'min-width': '30rem',
    }
  },
  subsectionThreeTitle: {
    '0': {
      ...typoSmall,
      'margin-bottom': '6rem'
    },
    '37_5': {
      'margin-top': '6rem'
    }
  },
  subsectionThreeContent: {
    '0': {
      ...typoParagraph,
      'display': 'flex',
      'flex-direction': 'column'
    },
    '37_5': {
      'font-size': '2.4rem'
    }
  },
  bottomlineWrapper: {
    '0': {
      'display': 'flex',
      'margin-top': '15rem'
    },
    '76_8': {
      'margin-top': '10rem',
      'flex-wrap': 'wrap',
      'flex-direction': 'column'
    },

  },
  socialIconsWrapper: {
    '0': {
      'flex': '1',
      'display': 'flex',
      'flex-direction': 'column',
      'order': '2',
      'padding-left': '30rem'
    },
    '76_8': {
      'order': '1',
      'padding-left': '0'
    },
    '37_5': {
      'width': '100%'
    }
  },
  socialIconsTitle: {
    '0': {
      ...typoSmall,
      'margin-bottom': '6rem'
    },
  },
  socialIconsContent: {
    '0': {
      'display': 'flex',
      'justify-content': 'space-between',
      'max-width': '40rem'
    },
  },
  footerFacebookIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${facebookIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  footerLinkedinIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${linkedinIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  footerTwitterIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${twitterIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  footerInstagramIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'margin-right': '1.5rem',
      'background-image': `url(${instagramIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
  footerSlackIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float': 'left',
      'background-image': `url(${slackIcon})`,
    },
    '37_5': {
      'margin-right': '0.6rem',
    }
  },
};
